import { render, staticRenderFns } from "./VideoSeriesHosts.vue?vue&type=template&id=4f22bed8&"
import script from "./VideoSeriesHosts.vue?vue&type=script&lang=js&"
export * from "./VideoSeriesHosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports